module.exports = __webpack_public_path__ + "img/cm-1.7223e32d.png";